import React from "react";
import { MONTH_NAMES, WEEKDAY_LABELS, buildMonthCells, dayKind } from "./spr-holidays-utils";

const SprHolidaysMonth = ({ year, monthIndex, holidayMap, selectedKey, onSelect, onToggle }) => {
  const cells = buildMonthCells(year, monthIndex);

  return (
    <section className="spr-holidays-month" aria-label={MONTH_NAMES[monthIndex]}>
      <h3 className="spr-holidays-month__title">{MONTH_NAMES[monthIndex]}</h3>
      <div className="spr-holidays-month__weekdays">
        {WEEKDAY_LABELS.map((label) => (
          <span key={label} className="spr-holidays-month__weekday">
            {label}
          </span>
        ))}
      </div>
      <div className="spr-holidays-month__days">
        {cells.map((cell, idx) => {
          if (cell.day == null) {
            return <span key={`e-${idx}`} className="spr-holidays-month__day spr-holidays-month__day--empty" />;
          }
          const kind = dayKind(cell.dateKey, cell.weekday, holidayMap);
          const selected = cell.dateKey === selectedKey;
          return (
            <button
              key={cell.dateKey}
              type="button"
              className={[
                "spr-holidays-month__day",
                `spr-holidays-month__day--${kind}`,
                selected ? "spr-holidays-month__day--selected" : ""
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={() => onSelect(cell.dateKey)}
              onDoubleClick={(e) => {
                e.preventDefault();
                onToggle(cell.dateKey);
              }}
            >
              {cell.day}
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default SprHolidaysMonth;
